import { DROP_TYPES, type DeliveryState, type DropType, type InventoryState } from './types';
import { GAME } from './config';
import type { SeededRandom } from './rng';

export function createInventory(): InventoryState {
  return {
    items: ['attractor', 'deflector', 'attractor', 'deflector'],
    overflow: null,
    expiredCount: 0,
  };
}

export function createDelivery(random: SeededRandom, now = 0): DeliveryState {
  const state: DeliveryState = {
    nextAt: now + GAME.deliveryInterval,
    upcoming: [],
    bag: [],
  };
  fillPreview(state, random);
  return state;
}

export function fillPreview(state: DeliveryState, random: SeededRandom): void {
  while (state.upcoming.length < GAME.previewCount) {
    if (state.bag.length === 0) state.bag = random.shuffle(DROP_TYPES);
    const next = state.bag.shift();
    if (next) state.upcoming.push(next);
  }
}

export function drawDelivery(state: DeliveryState, random: SeededRandom): DropType {
  const next = state.upcoming.shift();
  if (!next) throw new Error('Delivery preview must never be empty');
  fillPreview(state, random);
  state.nextAt += GAME.deliveryInterval;
  return next;
}

export function deliver(inventory: InventoryState, type: DropType, now: number): void {
  if (inventory.items.length < GAME.inventoryCapacity) {
    inventory.items.push(type);
    return;
  }
  inventory.overflow = { type, expiresAt: now + GAME.overflowDuration };
}

export function updateOverflow(inventory: InventoryState, now: number): void {
  if (!inventory.overflow) return;
  if (inventory.items.length < GAME.inventoryCapacity) {
    inventory.items.push(inventory.overflow.type);
    inventory.overflow = null;
  } else if (now >= inventory.overflow.expiresAt) {
    inventory.expiredCount += 1;
    inventory.overflow = null;
  }
}

export function consume(inventory: InventoryState, type: DropType): boolean {
  const index = inventory.items.indexOf(type);
  if (index < 0) return false;
  inventory.items.splice(index, 1);
  return true;
}

export function countItems(inventory: InventoryState): Map<DropType, number> {
  const counts = new Map<DropType, number>();
  for (const item of inventory.items) counts.set(item, (counts.get(item) ?? 0) + 1);
  return counts;
}
